import { $createParagraphNode, $getRoot } from "lexical"

export const $prepopulatedRichText = () => {
    const root = $getRoot()
    if (root.getFirstChild() === null) {
        const heading = $createParagraphNode()
        root.append(heading)
    }
}
